import React from "react";
import PropTypes from "prop-types";

import {
  Card,
  CardBody
} from "reactstrap";

const ActionPanel = ({ children }) => (
  <Card className="mb-4">
    <CardBody className="p-3">
      {children}
    </CardBody>
  </Card>
);

ActionPanel.propTypes = {
  children: PropTypes.node
};

ActionPanel.defaultProps = {
  children: null
};

export default ActionPanel;
